import { render, staticRenderFns } from "./issueslist.vue?vue&type=template&id=3fb67db5&scoped=true&"
import script from "./issueslist.vue?vue&type=script&lang=js&"
export * from "./issueslist.vue?vue&type=script&lang=js&"
import style0 from "./issueslist.vue?vue&type=style&index=0&id=3fb67db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb67db5",
  null
  
)

export default component.exports